// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dark .Docs-Root-Page h1{margin-bottom:4rem}", "",{"version":3,"sources":["webpack://./../src/docs/pages/RootPage.vue"],"names":[],"mappings":"AAGE,yBACC,kBAAA","sourcesContent":["\n.dark\n\t.Docs-Root-Page\n\t\th1\n\t\t\tmargin-bottom: 4rem\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
